import React from "react";
import { Link, RouteChildrenProps } from "react-router-dom";
import Shop from "./enum/Shop";
import "./index.css";
import "./index.less";
import Footer from "@/components/Footer";
import ShopType from "@/enum/ShopType";
import { observer } from "mobx-react-lite";

interface Props extends RouteChildrenProps {}

const Login: React.FC<Props> = () => {
    return (
        <div className="container-fluid pl20 pr20">
            <div className="page-header text-primary">
                <h3>
                    发货易登录 <small className="ml10">请点击相应平台图标进行登录</small>
                </h3>
            </div>
            <div className="flex">
                <div className="f1">
                    {Object.keys(Shop).map((key: ShopType, index) => {
                        const url = Shop[key].auth;

                        const img = <img src={Shop[key].image} alt="" style={{ width: "160px", height: "70px" }} />;

                        let a;

                        if (!Shop[key].auth.startsWith("http")) {
                            a = <Link to={url}>{img}</Link>;
                        } else {
                            a = <a href={Shop[key].auth}>{img}</a>;
                        }

                        return (
                            <span style={{ width: "20%", display: "inline-block" }} key={index} className="mb30">
                                {a}
                            </span>
                        );
                    })}
                </div>

                <div
                    className="ml5"
                    style={{
                        paddingLeft: 25,
                        borderLeft: "1px solid rgba(0, 0, 0, 0.06)",
                        width: "25%",
                        textAlign: "center",
                    }}
                >
                    <div>
                        <Link to="/login/independentManual">
                            <img
                                src="https://img.alicdn.com/imgextra/i2/54458674/O1CN01tNfhwz2DwkHdjUDH1_!!54458674.jpg"
                                alt=""
                                style={{ width: 200, height: 140 }}
                            />
                        </Link>
                    </div>
                    <div className="mt20">
                        <Link to="/partnership/login">
                            <img
                                src="https://img.alicdn.com/imgextra/i2/54458674/O1CN01evjCIV2DwkI0VBfLG_!!54458674.png"
                                alt=""
                                style={{ width: 200, height: 140 }}
                            />
                        </Link>
                    </div>

                    <p className="mt15 fs12 text-light">
                        代理商和供货商均可查看
                        <a
                            href="https://qw15p3s8hv.feishu.cn/wiki/wikcnRYdGBlj41hSYkNmpj5hexf"
                            target="_blank"
                            style={{ textDecoration: "underline", color: "#0377a2", marginLeft: 5 }}
                        >
                            分销代发方案
                        </a>
                    </p>
                </div>
            </div>

            <br />
            <br />
            <br />
            <br />
            <br />

            <Footer />
        </div>
    );
};

export default observer(Login);
